import React from "react";
import PizzaLeft from "../assets/pizzaLeft.jpg";
import "../styles/Contact.css";
import { motion } from "framer-motion";

function Contact() {
  return (
    <>
      <motion.div
        className="contact-container"
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -20, scale: 0.95 }}
        transition={{
          duration: 0.6,
          ease: [0.25, 0.8, 0.25, 1],
        }}
      >
        <div
          className="contact-left"
          style={{ backgroundImage: `url(${PizzaLeft})` }}
        ></div>

        <div className="contact-right">
          <h1>
            Contact <span>Us</span>
          </h1>
          <form id="contact-form" method="POST">
            <label htmlFor="name">Full Name</label>
            <input name="name" placeholder="Enter full name..." type="text" required />

            <label htmlFor="email">Email</label>
            <input name="email" placeholder="Enter email..." type="email" required />

            <label htmlFor="message">Message</label>
            <textarea
              rows="6"
              placeholder="Enter message..."
              name="message"
              required
            ></textarea>

            <button type="submit">Send Message</button>
          </form>
        </div>
      </motion.div>

      <div className="map-section">
        <iframe
          title="Google Map - Pedro's Pizzeria"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0097426098637!2d-122.41941508468374!3d37.77492977975964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808c7c17fdd5%3A0xd4a037f0ee2e0d1c!2sPizza%20Place!5e0!3m2!1sen!2sus!4v1620240000000!5m2!1sen!2sus"
          width="100%"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </>
  );
}

export default Contact;
